import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // Navigation
      "nav.home": "Inicio",
      "nav.login": "Iniciar Sesión",
      "nav.register": "Registrarse",
      "nav.dashboard": "Panel",
      "nav.logout": "Cerrar Sesión",
      "nav.admin": "Admin",
      
      // Landing
      "hero.title": "Gestión de Garantías",
      "hero.subtitle": "Simple. Rápido. Eficiente.",
      "hero.description": "Tu portal de confianza para gestionar devoluciones y garantías de productos electrónicos.",
      "hero.cta": "Comenzar",
      "hero.login": "Ya tengo cuenta",
      
      // Features
      "features.title": "¿Por qué elegirnos?",
      "features.warranty.title": "Garantía Simplificada",
      "features.warranty.desc": "Proceso de garantía en pocos clics. Seguimiento en tiempo real.",
      "features.shipping.title": "Envío Gratuito",
      "features.shipping.desc": "Etiquetas de envío Correos incluidas sin coste adicional.",
      "features.support.title": "Soporte Dedicado",
      "features.support.desc": "Atención personalizada durante todo el proceso.",
      "features.fast.title": "Respuesta Rápida",
      "features.fast.desc": "Tiempo estimado de 7 a 30 días laborables.",
      
      // How it works
      "howItWorks.title": "¿Cómo funciona?",
      "howItWorks.step1.title": "1. Crea tu solicitud",
      "howItWorks.step1.desc": "Rellena el formulario con los datos del producto y el problema.",
      "howItWorks.step2.title": "2. Envía el producto",
      "howItWorks.step2.desc": "Usa la etiqueta de Correos gratuita que te proporcionamos.",
      "howItWorks.step3.title": "3. Seguimiento",
      "howItWorks.step3.desc": "Monitoriza el estado de tu solicitud en tiempo real.",
      "howItWorks.step4.title": "4. Recibe tu producto",
      "howItWorks.step4.desc": "Te lo devolvemos reparado o reemplazado.",
      
      // Auth
      "auth.login.title": "Iniciar Sesión",
      "auth.login.email": "Correo electrónico",
      "auth.login.password": "Contraseña",
      "auth.login.submit": "Entrar",
      "auth.login.google": "Continuar con Google",
      "auth.login.noAccount": "¿No tienes cuenta?",
      "auth.login.register": "Regístrate aquí",
      
      "auth.register.title": "Crear Cuenta",
      "auth.register.name": "Nombre completo",
      "auth.register.email": "Correo electrónico",
      "auth.register.password": "Contraseña",
      "auth.register.submit": "Registrarse",
      "auth.register.google": "Registrarse con Google",
      "auth.register.hasAccount": "¿Ya tienes cuenta?",
      "auth.register.login": "Inicia sesión aquí",
      
      // Dashboard
      "dashboard.title": "Mi Panel",
      "dashboard.welcome": "Bienvenido/a",
      "dashboard.warranty.new": "Nueva Solicitud de Garantía",
      "dashboard.warranty.check": "Consultar Garantías",
      "dashboard.invoice.new": "Solicitar Factura",
      "dashboard.invoice.check": "Consultar Facturas",
      
      // Warranty Form
      "warranty.title": "Nueva Solicitud de Garantía",
      "warranty.personal": "Datos Personales",
      "warranty.product": "Datos del Producto",
      "warranty.problem": "Descripción del Problema",
      
      "warranty.fullName": "Nombre completo",
      "warranty.street": "Calle",
      "warranty.number": "Número",
      "warranty.piso": "Piso",
      "warranty.puerta": "Puerta",
      "warranty.postalCode": "Código Postal",
      "warranty.comunidad": "Comunidad Autónoma",
      "warranty.municipio": "Municipio",
      "warranty.country": "País",
      "warranty.phone": "Teléfono",
      "warranty.email": "Email",
      
      "warranty.productName": "Nombre del Producto",
      "warranty.serialNumber": "Número de Serie",
      "warranty.serialWarning": "El producto enviado debe coincidir con el comprado",
      "warranty.purchaseDate": "Fecha de Compra",
      "warranty.purchaseSource": "Lugar de Compra",
      "warranty.orderId": "ID de Pedido",
      "warranty.photos": "Fotos del Producto",
      "warranty.problemDesc": "Describe el problema",
      
      "warranty.submit": "Enviar Solicitud",
      "warranty.success.title": "¡Solicitud Enviada!",
      "warranty.success.desc": "Recibirás un email con los detalles y la etiqueta de envío.",
      "warranty.success.label": "Para España: Recibirás una etiqueta de Correos gratuita.",
      "warranty.success.time": "Tiempo estimado: 7-30 días laborables.",
      
      // Warranty Status
      "status.open": "Solicitud Abierta",
      "status.transit": "En Tránsito al Servicio Técnico",
      "status.delivered": "Entregado en Servicio Técnico",
      "status.checking": "Haciendo Comprobaciones",
      "status.repairing": "En Reparación",
      "status.repaired": "Reparado",
      "status.replaced": "Sustituido / Reemplazado",
      "status.shipped": "Enviado al Cliente",
      "status.completed": "RMA Completado",
      
      // Invoice Form
      "invoice.title": "Solicitar Factura",
      "invoice.nif": "NIF / CIF / DNI",
      "invoice.submit": "Solicitar Factura",
      "invoice.pending": "Pendiente",
      "invoice.completed": "Completada",
      
      // Common
      "common.loading": "Cargando...",
      "common.error": "Ha ocurrido un error",
      "common.retry": "Reintentar",
      "common.back": "Volver",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.next": "Siguiente",
      "common.previous": "Anterior",
      "common.optional": "Opcional",
      "common.required": "Requerido",
      
      // Footer
      "footer.rights": "Todos los derechos reservados",
      "footer.privacy": "Política de Privacidad",
      "footer.terms": "Términos y Condiciones",
      "footer.contact": "Contacto",
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.login": "Login",
      "nav.register": "Register",
      "nav.dashboard": "Dashboard",
      "nav.logout": "Logout",
      "nav.admin": "Admin",
      
      // Landing
      "hero.title": "Warranty Management",
      "hero.subtitle": "Simple. Fast. Efficient.",
      "hero.description": "Your trusted portal for managing electronics returns and warranties.",
      "hero.cta": "Get Started",
      "hero.login": "I have an account",
      
      // Features
      "features.title": "Why Choose Us?",
      "features.warranty.title": "Simplified Warranty",
      "features.warranty.desc": "Warranty process in just a few clicks. Real-time tracking.",
      "features.shipping.title": "Free Shipping",
      "features.shipping.desc": "Correos shipping labels included at no extra cost.",
      "features.support.title": "Dedicated Support",
      "features.support.desc": "Personalized attention throughout the process.",
      "features.fast.title": "Fast Response",
      "features.fast.desc": "Estimated time of 7 to 30 business days.",
      
      // How it works
      "howItWorks.title": "How It Works?",
      "howItWorks.step1.title": "1. Create your request",
      "howItWorks.step1.desc": "Fill out the form with product details and the issue.",
      "howItWorks.step2.title": "2. Ship the product",
      "howItWorks.step2.desc": "Use the free Correos label we provide.",
      "howItWorks.step3.title": "3. Track",
      "howItWorks.step3.desc": "Monitor your request status in real-time.",
      "howItWorks.step4.title": "4. Receive your product",
      "howItWorks.step4.desc": "We return it repaired or replaced.",
      
      // Auth
      "auth.login.title": "Login",
      "auth.login.email": "Email",
      "auth.login.password": "Password",
      "auth.login.submit": "Sign In",
      "auth.login.google": "Continue with Google",
      "auth.login.noAccount": "Don't have an account?",
      "auth.login.register": "Register here",
      
      "auth.register.title": "Create Account",
      "auth.register.name": "Full name",
      "auth.register.email": "Email",
      "auth.register.password": "Password",
      "auth.register.submit": "Register",
      "auth.register.google": "Register with Google",
      "auth.register.hasAccount": "Already have an account?",
      "auth.register.login": "Login here",
      
      // Dashboard
      "dashboard.title": "My Dashboard",
      "dashboard.welcome": "Welcome",
      "dashboard.warranty.new": "New Warranty Request",
      "dashboard.warranty.check": "Check Warranties",
      "dashboard.invoice.new": "Request Invoice",
      "dashboard.invoice.check": "Check Invoices",
      
      // Warranty Form
      "warranty.title": "New Warranty Request",
      "warranty.personal": "Personal Information",
      "warranty.product": "Product Information",
      "warranty.problem": "Problem Description",
      
      "warranty.fullName": "Full name",
      "warranty.street": "Street",
      "warranty.number": "Number",
      "warranty.piso": "Floor",
      "warranty.puerta": "Door",
      "warranty.postalCode": "Postal Code",
      "warranty.comunidad": "Region",
      "warranty.municipio": "City",
      "warranty.country": "Country",
      "warranty.phone": "Phone",
      "warranty.email": "Email",
      
      "warranty.productName": "Product Name",
      "warranty.serialNumber": "Serial Number",
      "warranty.serialWarning": "Product sent must match the purchased one",
      "warranty.purchaseDate": "Purchase Date",
      "warranty.purchaseSource": "Purchase Source",
      "warranty.orderId": "Order ID",
      "warranty.photos": "Product Photos",
      "warranty.problemDesc": "Describe the problem",
      
      "warranty.submit": "Submit Request",
      "warranty.success.title": "Request Submitted!",
      "warranty.success.desc": "You will receive an email with the details and shipping label.",
      "warranty.success.label": "For Spain: You will receive a free Correos label.",
      "warranty.success.time": "Estimated time: 7-30 business days.",
      
      // Warranty Status
      "status.open": "Request Open",
      "status.transit": "In Transit to Service",
      "status.delivered": "Delivered to Service",
      "status.checking": "Under Review",
      "status.repairing": "Under Repair",
      "status.repaired": "Repaired",
      "status.replaced": "Replaced",
      "status.shipped": "Shipped to Customer",
      "status.completed": "RMA Completed",
      
      // Invoice Form
      "invoice.title": "Request Invoice",
      "invoice.nif": "Tax ID",
      "invoice.submit": "Request Invoice",
      "invoice.pending": "Pending",
      "invoice.completed": "Completed",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.retry": "Retry",
      "common.back": "Back",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.next": "Next",
      "common.previous": "Previous",
      "common.optional": "Optional",
      "common.required": "Required",
      
      // Footer
      "footer.rights": "All rights reserved",
      "footer.privacy": "Privacy Policy",
      "footer.terms": "Terms and Conditions",
      "footer.contact": "Contact",
    }
  },
  fr: {
    translation: {
      "nav.home": "Accueil",
      "nav.login": "Connexion",
      "nav.register": "S'inscrire",
      "nav.dashboard": "Tableau de bord",
      "nav.logout": "Déconnexion",
      "nav.admin": "Admin",
      "hero.title": "Gestion des Garanties",
      "hero.subtitle": "Simple. Rapide. Efficace.",
      "hero.description": "Votre portail de confiance pour gérer les retours et garanties de produits électroniques.",
      "hero.cta": "Commencer",
      "hero.login": "J'ai un compte",
      "features.title": "Pourquoi nous choisir?",
      "features.warranty.title": "Garantie Simplifiée",
      "features.warranty.desc": "Processus de garantie en quelques clics. Suivi en temps réel.",
      "features.shipping.title": "Livraison Gratuite",
      "features.shipping.desc": "Étiquettes d'expédition Correos incluses sans frais supplémentaires.",
      "features.support.title": "Support Dédié",
      "features.support.desc": "Attention personnalisée tout au long du processus.",
      "features.fast.title": "Réponse Rapide",
      "features.fast.desc": "Délai estimé de 7 à 30 jours ouvrables.",
      "howItWorks.title": "Comment ça marche?",
      "howItWorks.step1.title": "1. Créez votre demande",
      "howItWorks.step1.desc": "Remplissez le formulaire avec les détails du produit et le problème.",
      "howItWorks.step2.title": "2. Envoyez le produit",
      "howItWorks.step2.desc": "Utilisez l'étiquette Correos gratuite que nous fournissons.",
      "howItWorks.step3.title": "3. Suivez",
      "howItWorks.step3.desc": "Suivez l'état de votre demande en temps réel.",
      "howItWorks.step4.title": "4. Recevez votre produit",
      "howItWorks.step4.desc": "Nous vous le retournons réparé ou remplacé.",
      "auth.login.title": "Connexion",
      "auth.login.email": "Email",
      "auth.login.password": "Mot de passe",
      "auth.login.submit": "Se connecter",
      "auth.login.google": "Continuer avec Google",
      "auth.login.noAccount": "Pas de compte?",
      "auth.login.register": "Inscrivez-vous ici",
      "auth.register.title": "Créer un compte",
      "auth.register.name": "Nom complet",
      "auth.register.email": "Email",
      "auth.register.password": "Mot de passe",
      "auth.register.submit": "S'inscrire",
      "auth.register.google": "S'inscrire avec Google",
      "auth.register.hasAccount": "Vous avez déjà un compte?",
      "auth.register.login": "Connectez-vous ici",
      "dashboard.title": "Mon Tableau de Bord",
      "dashboard.welcome": "Bienvenue",
      "dashboard.warranty.new": "Nouvelle Demande de Garantie",
      "dashboard.warranty.check": "Consulter les Garanties",
      "dashboard.invoice.new": "Demander une Facture",
      "dashboard.invoice.check": "Consulter les Factures",
      "warranty.title": "Nouvelle Demande de Garantie",
      "warranty.personal": "Informations Personnelles",
      "warranty.product": "Informations Produit",
      "warranty.problem": "Description du Problème",
      "warranty.fullName": "Nom complet",
      "warranty.street": "Rue",
      "warranty.number": "Numéro",
      "warranty.piso": "Étage",
      "warranty.puerta": "Porte",
      "warranty.postalCode": "Code Postal",
      "warranty.comunidad": "Région",
      "warranty.municipio": "Ville",
      "warranty.country": "Pays",
      "warranty.phone": "Téléphone",
      "warranty.email": "Email",
      "warranty.productName": "Nom du Produit",
      "warranty.serialNumber": "Numéro de Série",
      "warranty.serialWarning": "Le produit envoyé doit correspondre à celui acheté",
      "warranty.purchaseDate": "Date d'Achat",
      "warranty.purchaseSource": "Lieu d'Achat",
      "warranty.orderId": "ID de Commande",
      "warranty.photos": "Photos du Produit",
      "warranty.problemDesc": "Décrivez le problème",
      "warranty.submit": "Envoyer la Demande",
      "warranty.success.title": "Demande Envoyée!",
      "warranty.success.desc": "Vous recevrez un email avec les détails et l'étiquette d'expédition.",
      "warranty.success.label": "Pour l'Espagne: Vous recevrez une étiquette Correos gratuite.",
      "warranty.success.time": "Délai estimé: 7-30 jours ouvrables.",
      "status.open": "Demande Ouverte",
      "status.transit": "En Transit vers le Service",
      "status.delivered": "Livré au Service",
      "status.checking": "En Cours de Vérification",
      "status.repairing": "En Réparation",
      "status.repaired": "Réparé",
      "status.replaced": "Remplacé",
      "status.shipped": "Expédié au Client",
      "status.completed": "RMA Terminé",
      "invoice.title": "Demander une Facture",
      "invoice.nif": "Numéro Fiscal",
      "invoice.submit": "Demander la Facture",
      "invoice.pending": "En attente",
      "invoice.completed": "Terminée",
      "common.loading": "Chargement...",
      "common.error": "Une erreur s'est produite",
      "common.retry": "Réessayer",
      "common.back": "Retour",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.next": "Suivant",
      "common.previous": "Précédent",
      "common.optional": "Optionnel",
      "common.required": "Requis",
      "footer.rights": "Tous droits réservés",
      "footer.privacy": "Politique de Confidentialité",
      "footer.terms": "Conditions Générales",
      "footer.contact": "Contact",
    }
  },
  it: {
    translation: {
      "nav.home": "Home",
      "nav.login": "Accedi",
      "nav.register": "Registrati",
      "nav.dashboard": "Dashboard",
      "nav.logout": "Esci",
      "nav.admin": "Admin",
      "hero.title": "Gestione Garanzie",
      "hero.subtitle": "Semplice. Veloce. Efficiente.",
      "hero.description": "Il tuo portale di fiducia per gestire resi e garanzie di prodotti elettronici.",
      "hero.cta": "Inizia",
      "hero.login": "Ho un account",
      "features.title": "Perché Sceglierci?",
      "features.warranty.title": "Garanzia Semplificata",
      "features.warranty.desc": "Processo di garanzia in pochi clic. Tracciamento in tempo reale.",
      "features.shipping.title": "Spedizione Gratuita",
      "features.shipping.desc": "Etichette di spedizione Correos incluse senza costi aggiuntivi.",
      "features.support.title": "Supporto Dedicato",
      "features.support.desc": "Attenzione personalizzata durante tutto il processo.",
      "features.fast.title": "Risposta Rapida",
      "features.fast.desc": "Tempo stimato da 7 a 30 giorni lavorativi.",
      "howItWorks.title": "Come Funziona?",
      "howItWorks.step1.title": "1. Crea la tua richiesta",
      "howItWorks.step1.desc": "Compila il modulo con i dettagli del prodotto e il problema.",
      "howItWorks.step2.title": "2. Spedisci il prodotto",
      "howItWorks.step2.desc": "Usa l'etichetta Correos gratuita che forniamo.",
      "howItWorks.step3.title": "3. Monitora",
      "howItWorks.step3.desc": "Segui lo stato della tua richiesta in tempo reale.",
      "howItWorks.step4.title": "4. Ricevi il tuo prodotto",
      "howItWorks.step4.desc": "Te lo restituiamo riparato o sostituito.",
      "auth.login.title": "Accedi",
      "auth.login.email": "Email",
      "auth.login.password": "Password",
      "auth.login.submit": "Accedi",
      "auth.login.google": "Continua con Google",
      "auth.login.noAccount": "Non hai un account?",
      "auth.login.register": "Registrati qui",
      "auth.register.title": "Crea Account",
      "auth.register.name": "Nome completo",
      "auth.register.email": "Email",
      "auth.register.password": "Password",
      "auth.register.submit": "Registrati",
      "auth.register.google": "Registrati con Google",
      "auth.register.hasAccount": "Hai già un account?",
      "auth.register.login": "Accedi qui",
      "dashboard.title": "La Mia Dashboard",
      "dashboard.welcome": "Benvenuto/a",
      "dashboard.warranty.new": "Nuova Richiesta di Garanzia",
      "dashboard.warranty.check": "Consulta Garanzie",
      "dashboard.invoice.new": "Richiedi Fattura",
      "dashboard.invoice.check": "Consulta Fatture",
      "warranty.title": "Nuova Richiesta di Garanzia",
      "warranty.personal": "Dati Personali",
      "warranty.product": "Dati Prodotto",
      "warranty.problem": "Descrizione del Problema",
      "warranty.fullName": "Nome completo",
      "warranty.street": "Via",
      "warranty.number": "Numero",
      "warranty.piso": "Piano",
      "warranty.puerta": "Porta",
      "warranty.postalCode": "Codice Postale",
      "warranty.comunidad": "Regione",
      "warranty.municipio": "Città",
      "warranty.country": "Paese",
      "warranty.phone": "Telefono",
      "warranty.email": "Email",
      "warranty.productName": "Nome Prodotto",
      "warranty.serialNumber": "Numero di Serie",
      "warranty.serialWarning": "Il prodotto inviato deve corrispondere a quello acquistato",
      "warranty.purchaseDate": "Data di Acquisto",
      "warranty.purchaseSource": "Luogo di Acquisto",
      "warranty.orderId": "ID Ordine",
      "warranty.photos": "Foto del Prodotto",
      "warranty.problemDesc": "Descrivi il problema",
      "warranty.submit": "Invia Richiesta",
      "warranty.success.title": "Richiesta Inviata!",
      "warranty.success.desc": "Riceverai un'email con i dettagli e l'etichetta di spedizione.",
      "warranty.success.label": "Per la Spagna: Riceverai un'etichetta Correos gratuita.",
      "warranty.success.time": "Tempo stimato: 7-30 giorni lavorativi.",
      "status.open": "Richiesta Aperta",
      "status.transit": "In Transito al Servizio",
      "status.delivered": "Consegnato al Servizio",
      "status.checking": "In Verifica",
      "status.repairing": "In Riparazione",
      "status.repaired": "Riparato",
      "status.replaced": "Sostituito",
      "status.shipped": "Spedito al Cliente",
      "status.completed": "RMA Completato",
      "invoice.title": "Richiedi Fattura",
      "invoice.nif": "Codice Fiscale",
      "invoice.submit": "Richiedi Fattura",
      "invoice.pending": "In attesa",
      "invoice.completed": "Completata",
      "common.loading": "Caricamento...",
      "common.error": "Si è verificato un errore",
      "common.retry": "Riprova",
      "common.back": "Indietro",
      "common.save": "Salva",
      "common.cancel": "Annulla",
      "common.next": "Avanti",
      "common.previous": "Precedente",
      "common.optional": "Opzionale",
      "common.required": "Richiesto",
      "footer.rights": "Tutti i diritti riservati",
      "footer.privacy": "Privacy Policy",
      "footer.terms": "Termini e Condizioni",
      "footer.contact": "Contatti",
    }
  },
  de: {
    translation: {
      "nav.home": "Startseite",
      "nav.login": "Anmelden",
      "nav.register": "Registrieren",
      "nav.dashboard": "Dashboard",
      "nav.logout": "Abmelden",
      "nav.admin": "Admin",
      "hero.title": "Garantieverwaltung",
      "hero.subtitle": "Einfach. Schnell. Effizient.",
      "hero.description": "Ihr vertrauenswürdiges Portal für die Verwaltung von Elektronik-Retouren und Garantien.",
      "hero.cta": "Loslegen",
      "hero.login": "Ich habe ein Konto",
      "features.title": "Warum uns wählen?",
      "features.warranty.title": "Vereinfachte Garantie",
      "features.warranty.desc": "Garantieprozess mit wenigen Klicks. Echtzeit-Tracking.",
      "features.shipping.title": "Kostenloser Versand",
      "features.shipping.desc": "Correos-Versandetiketten ohne zusätzliche Kosten enthalten.",
      "features.support.title": "Persönlicher Support",
      "features.support.desc": "Persönliche Betreuung während des gesamten Prozesses.",
      "features.fast.title": "Schnelle Antwort",
      "features.fast.desc": "Geschätzte Zeit von 7 bis 30 Werktagen.",
      "howItWorks.title": "Wie funktioniert es?",
      "howItWorks.step1.title": "1. Erstellen Sie Ihre Anfrage",
      "howItWorks.step1.desc": "Füllen Sie das Formular mit den Produktdetails und dem Problem aus.",
      "howItWorks.step2.title": "2. Versenden Sie das Produkt",
      "howItWorks.step2.desc": "Verwenden Sie das kostenlose Correos-Etikett, das wir bereitstellen.",
      "howItWorks.step3.title": "3. Verfolgen",
      "howItWorks.step3.desc": "Überwachen Sie den Status Ihrer Anfrage in Echtzeit.",
      "howItWorks.step4.title": "4. Erhalten Sie Ihr Produkt",
      "howItWorks.step4.desc": "Wir senden es repariert oder ersetzt zurück.",
      "auth.login.title": "Anmelden",
      "auth.login.email": "E-Mail",
      "auth.login.password": "Passwort",
      "auth.login.submit": "Einloggen",
      "auth.login.google": "Mit Google fortfahren",
      "auth.login.noAccount": "Kein Konto?",
      "auth.login.register": "Hier registrieren",
      "auth.register.title": "Konto erstellen",
      "auth.register.name": "Vollständiger Name",
      "auth.register.email": "E-Mail",
      "auth.register.password": "Passwort",
      "auth.register.submit": "Registrieren",
      "auth.register.google": "Mit Google registrieren",
      "auth.register.hasAccount": "Haben Sie bereits ein Konto?",
      "auth.register.login": "Hier anmelden",
      "dashboard.title": "Mein Dashboard",
      "dashboard.welcome": "Willkommen",
      "dashboard.warranty.new": "Neue Garantieanfrage",
      "dashboard.warranty.check": "Garantien prüfen",
      "dashboard.invoice.new": "Rechnung anfordern",
      "dashboard.invoice.check": "Rechnungen prüfen",
      "warranty.title": "Neue Garantieanfrage",
      "warranty.personal": "Persönliche Daten",
      "warranty.product": "Produktdaten",
      "warranty.problem": "Problembeschreibung",
      "warranty.fullName": "Vollständiger Name",
      "warranty.street": "Straße",
      "warranty.number": "Nummer",
      "warranty.piso": "Etage",
      "warranty.puerta": "Tür",
      "warranty.postalCode": "Postleitzahl",
      "warranty.comunidad": "Region",
      "warranty.municipio": "Stadt",
      "warranty.country": "Land",
      "warranty.phone": "Telefon",
      "warranty.email": "E-Mail",
      "warranty.productName": "Produktname",
      "warranty.serialNumber": "Seriennummer",
      "warranty.serialWarning": "Das gesendete Produkt muss dem gekauften entsprechen",
      "warranty.purchaseDate": "Kaufdatum",
      "warranty.purchaseSource": "Kaufort",
      "warranty.orderId": "Bestell-ID",
      "warranty.photos": "Produktfotos",
      "warranty.problemDesc": "Beschreiben Sie das Problem",
      "warranty.submit": "Anfrage senden",
      "warranty.success.title": "Anfrage gesendet!",
      "warranty.success.desc": "Sie erhalten eine E-Mail mit den Details und dem Versandetikett.",
      "warranty.success.label": "Für Spanien: Sie erhalten ein kostenloses Correos-Etikett.",
      "warranty.success.time": "Geschätzte Zeit: 7-30 Werktage.",
      "status.open": "Anfrage offen",
      "status.transit": "Im Transit zum Service",
      "status.delivered": "Beim Service angekommen",
      "status.checking": "In Prüfung",
      "status.repairing": "In Reparatur",
      "status.repaired": "Repariert",
      "status.replaced": "Ersetzt",
      "status.shipped": "An Kunden versendet",
      "status.completed": "RMA abgeschlossen",
      "invoice.title": "Rechnung anfordern",
      "invoice.nif": "Steuernummer",
      "invoice.submit": "Rechnung anfordern",
      "invoice.pending": "Ausstehend",
      "invoice.completed": "Abgeschlossen",
      "common.loading": "Laden...",
      "common.error": "Ein Fehler ist aufgetreten",
      "common.retry": "Erneut versuchen",
      "common.back": "Zurück",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.next": "Weiter",
      "common.previous": "Zurück",
      "common.optional": "Optional",
      "common.required": "Erforderlich",
      "footer.rights": "Alle Rechte vorbehalten",
      "footer.privacy": "Datenschutz",
      "footer.terms": "Allgemeine Geschäftsbedingungen",
      "footer.contact": "Kontakt",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
